<template>
  <div v-if="this.response != null">
    <div align="center">
      <div class="Flex_Table pay_table" style="border: 1px solid black; font-size: 16px">
        <div class="Flex_Row" style="text-align: center">
          <div class="Flex_Cell">
            <h2>Refund Status</h2>
            <hr />
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Refund Request Id</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ response.refundOrderID }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Refund Reference No.</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ response.aggrRefundID }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Refund Amount</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ response.refundAmount }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span v-if="response.refundStatus == 'REFUND_COMPLETED'">Refund Date & Time</span>
            <span>Refund Initiate Date & Time</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ new Date(response.refundDateTime).convertToString("dd-MMM-yyyy hh:mm tt") }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Refund Status</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span v-if="response.errorCode != ''" class="Failed">{{ response.errorDescription }}</span>
            <span
              v-else
              :class="response.refundStatus == 'REFUND_INITIATED'? 'Initiated' : 'Success'"
            >{{ response.refundStatus }}</span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div align="center">
      <div style="width: 80%">*Please noted the refund reference number for future reference</div>
    </div>
    <br />
    <div align="center">
      <span style="width: 160px"></span>
      <input type="button" v-on:click="redirectToForm()" value="Redirect to Main Form" />
      <input type="button" value="Print Receipt" @click="printReceipt" v-if="false" />
    </div>
    <div v-if="response.errorCode == ''" style="color: red; margin-top: 0px; text-align: center">
      <img src="../assets/images/paysuccess.gif" class="status_img" />
    </div>
    <div v-if="response.refundStatus == 'REFUND_INITIATED'" align="center">
      <br />
      <h1 style="color: orange">Refund Initiated Successully !!</h1>
    </div>
    <div v-else-if="response.refundStatus == 'REFUND_COMPLETED'" align="center">
      <br />
      <h1 style="color: green">Refund Completed Successully !!</h1>
    </div>
    <div v-else style="color: red; margin-top: 0px; text-align: center">
      <img src="../assets/images/payerror.gif" class="status_img" />
      <div v-if="response.errorCode != ''" align="center">
        <br />
        <h1 style="color: Red">Refund Failed !!</h1>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RefundResponse",
  components: {},
  data() {
    return {
      response: null,
      pageName: "",
      bookingID: -1,
      CancelReason: ""
    };
  },
  methods: {
    redirectToForm() {
      this.$root.$data.BookingID = this.bookingID;
      this.$root.$data.isSuccess = this.response.errorCode != "" ? false : true;
      this.$root.$data.isRefund = true;
      this.$router.push({ name: this.pageName });
    }
  },
  mounted() {
    if (this.$root.$data.BookingID != null) {
      let me = this;
      this.response = this.$root.$data.Response;
      this.pageName = this.$root.$data.PageName;
      this.bookingID = this.$root.$data.BookingID;
      this.CancelReason = this.$root.$data.CancelReason;
      // console.log(this.$root.$data.Response);
      // window.setTimeout(function() {
      //   // me.getData();
      // }, 3000);
    } else {
      this.$router.push({ name: "Home" });
    }
  }
};
</script>
<style>
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
</style>
<style scoped>
.Success {
  color: green;
}
.Initiated {
  color: orange;
}
.Failed {
  color: red;
}

.pay_table {
  width: 40%;
}

.status_img {
  height: 13%;
  width: 13%;
}

@media screen and (max-width: 800px) {
  .pay_table {
    width: 60%;
  }

  .status_img {
    height: 23%;
    width: 23%;
  }
}

@media screen and (max-width: 480px) {
  .pay_table {
    width: 70%;
  }

  .status_img {
    height: 30%;
    width: 30%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RefundResponse.vue